export enum InvoiceStatusEnum {
  ENVIADO = "Enviado",
  APROVADO = "Aprovado",
  NAO_APROVADO = "Não Aprovado",
}
